import { useState, useCallback } from "react";
import useLenis from "../hooks/useLenis";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/sections/About";
import Products from "../components/sections/Products";
import WhyChoose from "../components/sections/WhyChoose";
import PlasticImpact from "../components/sections/PlasticImpact";
import Sustainability from "../components/sections/Sustainability";
import GlobalExport from "../components/sections/GlobalExport";
import Quality from "../components/sections/Quality";
import Testimonials from "../components/sections/Testimonials";
import FAQSection from "../components/sections/FAQSection";
import Contact from "../components/sections/Contact";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import ChatWidget from "../components/ChatWidget";

export default function Home() {
  useLenis();
  const [prefill, setPrefill] = useState("");

  const goToContact = useCallback((product) => {
    if (product) setPrefill(product);
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="bg-verra-base">
      <Navbar onQuote={() => goToContact("")} />
      <main>
        <Hero onQuote={() => goToContact("")} />
        <Marquee />
        <About />
        <Products onInquire={(name) => goToContact(name)} />
        <WhyChoose />
        <PlasticImpact onQuote={() => goToContact("")} />
        <Sustainability />
        <GlobalExport />
        <Quality />
        <Testimonials />
        <FAQSection />
        <Contact prefill={prefill} />
      </main>
      <Footer />
      <FloatingButtons />
      <ChatWidget />
    </div>
  );
}
